import { http } from "@/utils/http";
export const getPaySign = () => {
  // 获取支付时的参数
  return http({
    url: `/1/pangpay/sign`,
    method: "get",
  });
};
export const getPaymentMethods = () => {
  // 获取支付方式
  return http({
    url: `/1/rechargerecords/payments`,
    method: "get",
  });
};
export const postRecharge = (params) => {
  // 提交充值记录
  return http({
    url: `/1/rechargerecords`,
    method: "post",
    data: params,
  });
};
export const approval = (id, params) => {
  // 核准订单
  return http({
    url: `/1/rechargerecords/${id}/pay`,
    method: "post",
    data: params,
  });
};
export const postPropRecord = (params) => {
  // 购买元宝
  return http({
    url: `/1/proprecords`,
    method: "post",
    data: params,
  });
};
